import { render, staticRenderFns } from "./saleBase.vue?vue&type=template&id=51a11526&"
import script from "./saleBase.vue?vue&type=script&lang=js&"
export * from "./saleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports